/*
 * Get all application flags for the current user has access to (with role data)
 */
import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';
import type { ApplicationFlagEntry } from '/business/shared/state/reducers/applicationFlags';

export default (state: RootState): ApplicationFlagEntry[] => state.applicationFlags?.applications || EMPTY_ARRAY;
